// Alias
import DefaultFooter from '../../footer';

export default DefaultFooter;



// WEBPACK FOOTER //
// ./components/lookup/menu/default-header/index.jsx